import { safeParse } from "valibot"
import type { Nullable } from "../../../typescript"
import isString from "../../ldsh/isString"
import { PlayerColorSchema } from "./PlayerColor.type"



export default function coerceToColorIntegerOrNull(str: Nullable<string | number>) : number | null {
  if (str) {
    if (isString(str)) {
      if (str.startsWith('#')) {
        str = '0x' + str.slice(1)
      }
      str = Number(str)
    }
    const result = safeParse(PlayerColorSchema, str)
    if (result.success) {
      return result.output
    }
  }
  return null
}